// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* NOU */

/* index.css */
body {
  margin: 0;
  font-family: 'Roboto', Arial, sans-serif;
  background-color: #f8f9fa;
  color: #212529;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
}

a {
  text-decoration: none;
  color: inherit;
}


.navbar {
  position: fixed;
  top: 0; /* Sempre enganxada a la part superior */
  left: 0;
  width: 100%; /* Ocupa tot l'ample de la pantalla */
  z-index: 100; /* Per assegurar que quedi per sobre del contingut */
  background-color: rgba(255, 255, 255, 0.9); /* Opcional: fons translúcid */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Opcional: petita ombra */
  transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out; /* Per animacions suaus */
}


/*.content {
  margin-top: 60px; /* Ajusta segons l'alçada de la barra 
}*/
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,QAAQ;;AAER,cAAc;AACd;EACE,SAAS;EACT,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,MAAM,EAAE,wCAAwC;EAChD,OAAO;EACP,WAAW,EAAE,qCAAqC;EAClD,YAAY,EAAE,oDAAoD;EAClE,0CAA0C,EAAE,8BAA8B;EAC1E,wCAAwC,EAAE,2BAA2B;EACrE,0EAA0E,EAAE,yBAAyB;AACvG;;;AAGA;;EAEE","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* NOU */\n\n/* index.css */\nbody {\n  margin: 0;\n  font-family: 'Roboto', Arial, sans-serif;\n  background-color: #f8f9fa;\n  color: #212529;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n\n.navbar {\n  position: fixed;\n  top: 0; /* Sempre enganxada a la part superior */\n  left: 0;\n  width: 100%; /* Ocupa tot l'ample de la pantalla */\n  z-index: 100; /* Per assegurar que quedi per sobre del contingut */\n  background-color: rgba(255, 255, 255, 0.9); /* Opcional: fons translúcid */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Opcional: petita ombra */\n  transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out; /* Per animacions suaus */\n}\n\n\n/*.content {\n  margin-top: 60px; /* Ajusta segons l'alçada de la barra \n}*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
